import * as React from 'react';
import {FormEvent} from 'react';

import Firebase, {withFirebase} from '../../components/Firebase';

import {Alert, Button, Form, Input} from 'antd';
import {WrappedFormUtils} from 'antd/lib/form/Form';


interface IAlert {
  message: string;
  type: 'error' | 'info' | 'success';
}

interface IProps {
  firebase: Firebase
  form: WrappedFormUtils
}

interface IState {
  alert: IAlert;
  signInBtnState: 'active' | 'loading' | 'disabled';
}


class SignInForm extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      alert: {
        message: '',
        type: 'info',
      },
      signInBtnState: 'active',
    };

  }


  private signInWithFirebase = (e: FormEvent<Event>) => {
    e.preventDefault();

    this.setState({
      signInBtnState: 'loading'
    });

    this.props.form.validateFields((err, values) => {

      if (!err) {
        const {email} = values;

        this.props.firebase.sendSignInLink(email)
          .then(() => {

            this.setState({
              alert: {
                message: `We have sent your authorization link to ${email}`,
                type: 'success'
              },
              signInBtnState: 'disabled'
            });
          })
          .catch((error) => {
            console.log(error);
            this.setState(() => ({
              alert: {
                message: `Ups, ${email} is not valid university email, please use official email`,
                type: 'error'
              },
              signInBtnState: 'active'
            }));

          });

      } else {
        this.setState({
          signInBtnState: 'active'
        })
      }

    });

  };

  public render() {
    const { getFieldDecorator } = this.props.form;

    const errorMessage = ((alert: IAlert) => {
      if (alert.message !== '') {

        return <Alert message={alert.message} type={alert.type}
                      banner={true}
                      showIcon={false}
                      style={{width: '100%'}}/>;
      }
      return null;
    })(this.state.alert);

    const isSignInBtnLoading = this.state.signInBtnState === 'loading';
    const isSignInBtnDisabled = this.state.signInBtnState === 'disabled';

    return(
        <Form style={{width: '100%'}} onSubmit={this.signInWithFirebase}>
          <h3 style={{textAlign: 'center'}}>Sign in with your university email</h3>
          <Form.Item>
            {getFieldDecorator('email', {
              rules: [{ required: true, message: 'Please input your email!' }],
            })(
              <Input type='email' placeholder='Enter your email'/>
            )}
          </Form.Item>
          <Form.Item>
            <Button
              loading={isSignInBtnLoading}
              disabled={isSignInBtnDisabled}
              htmlType="submit"
              size='large'>
              Send me authorization link
            </Button>
          </Form.Item>
          {errorMessage}
        </Form>
    )
  }


}

export default Form.create()(
  withFirebase(SignInForm)
);